import { render, staticRenderFns } from "./UnitsSelect.vue?vue&type=template&id=52a02ab8&"
import script from "./UnitsSelect.vue?vue&type=script&lang=js&"
export * from "./UnitsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports